import React from 'react';
import { useTranslation } from 'react-i18next';

import StepConfig from '../../../shared/stores/models/StepConfig';
import { StepInfoType } from '../../../shared/types/FieldModelTypes';
import { ExtraHeaderUIDetailsType } from '../../../shared/types/zodSchemaTypes';

import { formExtraHeaderUIType } from '../../constants/FormConstants';
import { scholarshipIconUrl } from '../../constants/ImageConstants';

import {
  ExtraHeaderUIContainer,
  ExtraHeaderUITitle,
  ExtraHeaderUITitleContainer,
  GiftIcon,
  ScholarshipImage,
  WebinarRegistrationFormContainer,
  WebinarRegistrationFormDescription,
  WebinarRegistrationFormTitle
} from './styledComponent';

interface FormExtraHeaderUIProps {
  eachFormStep: StepConfig;
}

const FormExtraHeaderUI: React.FC<FormExtraHeaderUIProps> = ({
  eachFormStep
}): React.ReactElement | null => {
  const { stepInfo } = eachFormStep as StepConfig;
  const { extra_header_ui_details } = stepInfo as StepInfoType;
  const { type, title, description } =
    extra_header_ui_details as ExtraHeaderUIDetailsType;
  const { t } = useTranslation();

  const renderScholarshipIcon = (): React.ReactElement => {
    return <ScholarshipImage src={scholarshipIconUrl} />;
  };

  switch (type) {
    case formExtraHeaderUIType.embeddedScholarshipFormUI:
      return (
        <ExtraHeaderUIContainer>
          <ExtraHeaderUITitleContainer>
            <ExtraHeaderUITitle>
              {t('scholarshipForm.header.getScholarshipHeading')}
            </ExtraHeaderUITitle>
          </ExtraHeaderUITitleContainer>
          {renderScholarshipIcon()}
        </ExtraHeaderUIContainer>
      );
    case formExtraHeaderUIType.embeddedAslScholarshipFormUI: {
      return (
        <ExtraHeaderUIContainer>
          <ExtraHeaderUITitleContainer>
            <ExtraHeaderUITitle>
              {t('scholarshipForm.header.applyForScholarship')}
            </ExtraHeaderUITitle>
            <ExtraHeaderUITitle>
              {t('scholarshipForm.header.getUpto16000')}
            </ExtraHeaderUITitle>
          </ExtraHeaderUITitleContainer>
          {renderScholarshipIcon()}
        </ExtraHeaderUIContainer>
      );
    }
    case formExtraHeaderUIType.webinarRegistrationFormUI: {
      return (
        <WebinarRegistrationFormContainer>
          <WebinarRegistrationFormTitle>{title}</WebinarRegistrationFormTitle>
          <WebinarRegistrationFormDescription>
            {description}
          </WebinarRegistrationFormDescription>
          <GiftIcon
            src="https://nxtwave-website-media-files.s3.ap-south-1.amazonaws.com/sso/webinars/iitians-webinar/gift_icon.png"
            alt="gift icon"
          />
        </WebinarRegistrationFormContainer>
      );
    }
    default:
      return null;
  }
};

export default FormExtraHeaderUI;
